"use client";

import { useUser } from "@/components/providers/user-provider";
import { useEffect } from "react";
import { redirect } from "next/navigation";
import { Loader2 } from "lucide-react";

export default function KBLayout({
    children,
}: {
    children: React.ReactNode;
}) {
    const { user, loading } = useUser();

    useEffect(() => {
        if (!loading && !user) {
            redirect("/");
        }
    }, [user, loading]);

    if (loading) {
        return (
            <div className="h-screen w-full flex items-center justify-center">
                <Loader2 className="h-8 w-8 animate-spin text-primary" />
            </div>
        );
    }

    if (!user) {
        return null;
    }

    return <>{children}</>;
}
